import React from "react";
import Workspace from "./Workspace";

const WorkspacePage = () => {
  return <Workspace />;
};

export default WorkspacePage;

